// the styles here, so that they stay in the HTML and the page never shows unstyled
import './directory.css';
import { boot } from '../lib/boot.js';

boot(() => import('./main.js'));
